import { NavItem } from '../../NavList'

export const hasNavItemSubItemSelected = <T>(items: NavItem<T>[], id: string, selectedId?: string): boolean => {
  const item = items.find((item) => item.id === id)
  return !!item?.subItems?.find((item) => item.id === selectedId)
}
